import { type ReactNode, useState, useCallback } from 'react';

const HEIGHTS = [
  35, 60, 45, 80, 55, 70, 40, 90, 50, 65, 75, 30, 85, 55, 42, 68, 52, 78, 38,
  72, 48, 82, 58, 62, 44, 88, 54, 74, 36, 66, 50, 73, 41, 87, 56, 69, 43, 77,
  53, 61, 46, 84, 39, 71, 57, 63, 47, 81, 37, 76,
];

export function ChartEmptyState(): ReactNode {
  const [count, setCount] = useState(50);
  const ref = useCallback((el: HTMLDivElement | null) => {
    if (el) setCount(Math.floor(el.clientWidth / 12));
  }, []);
  return (
    <div ref={ref} className="relative mt-md">
      <div className="flex h-32 w-full items-end gap-1">
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            className="w-2 shrink-0 rounded-t bg-white/[0.02]"
            style={{ height: `${HEIGHTS[i % HEIGHTS.length]}%` }}
          />
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center backdrop-blur-[2px]">
        <p className="rounded-lg bg-surface/80 px-md py-sm text-xs text-text-tertiary">
          Envía creadores para ver tu actividad
        </p>
      </div>
    </div>
  );
}
